import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class MATransactionService {
    static endpoint = '/v1/admin/ma_transactions';

    static async fetchTransactions(session, params) {
        const filterParams = this.parsedFilterParams(params.filterParams);
        return AdminClient.get(`${this.endpoint}`, session,
            {
                ...params,
                filterParams: filterParams,
            }
        );
    }

    static async create(session, transaction) {
        return AdminClient.post(`${this.endpoint}`, session, this.parsedTransaction({...transaction}));
    }

    static async update(itemId, session, transaction) {
        return AdminClient.put(`${this.endpoint}/${itemId}`, session, this.parsedTransaction({...transaction}));
    }

    static async edit(itemId, session) {
        return AdminClient.get(`${this.endpoint}/${itemId}/edit`, session);
    }

    static async extraOptions(session, params) {
        return AdminClient.get(`${this.endpoint}/extra_options`, session, params);
    }

    static async moveToDraft(transactionId, session) {
        return AdminClient.post(`${this.endpoint}/${transactionId}/move_to_draft`, session);
    }

    static async approve(transactionId, session) {
        return AdminClient.post(`${this.endpoint}/${transactionId}/approve`, session);
    }

    static async reject(transactionId, session) {
        return AdminClient.post(`${this.endpoint}/${transactionId}/reject`, session);
    }

    static async complete(transactionId, session) {
        return AdminClient.post(`${this.endpoint}/${transactionId}/complete`, session);
    }

    static async notes(transactionId, session) {
        return AdminClient.get(`/v1/admin/ma_transactions/${transactionId}/notes`, session);
    }

    static async notesCount(transactionId, session) {
        return AdminClient.get(`/v1/admin/ma_transactions/${transactionId}/notes_count`, session);
    }

    static async updateNews(transactionId, session, params) {
        return AdminClient.put(`${this.endpoint}/${transactionId}/update_news`, session, {edited_news: params});
    }

    static async news(transactionId, session) {
        return AdminClient.get(`${this.endpoint}/${transactionId}/related_news`, session);
    }

    static async triggeringContacts(transactionId, session, params) {
        return AdminClient.get(`${this.endpoint}/${transactionId}/triggering_contacts`, session, params);
    }

    static async getHistoricalFirmData(session, params) {
        return AdminClient.get(`${this.endpoint}/historical_firm_data`, session, params);
    }

    static async regenerateAiBio(transactionId, session) {
        return AdminClient.put(`${this.endpoint}/${transactionId}/regenerate_ai_bio`, session);
    }

    static parsedTransaction(transaction) {
        return {transaction};
    }

    static parsedFilterParams(params) {
        if (!_.isEmpty(params)) {
            return {
                ...params,
                bankers_used: mapIds(params.bankers_used || []),
                service_providers_used: mapIds(params.service_providers_used || []),
                researchers: mapIds(params.researchers),
                acquiring_firms: mapIds(params.acquiring_firms),
                acquired_firms: mapIds(params.acquired_firms),
                stages: mapIds(params.stages || []),
                statuses: mapIds(params.statuses || []),
                notes: mapIds(params.notes || []),
                sources: mapIds(params.sources || []),
                automatic_manual: mapIds(params.automatic_manual || []),
            }
        } else {
            return params;
        }
    }
}
export default MATransactionService;